import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button';

import footerBG from '../../assets/img/footer/bg-5.jpg';
import Logo from '../../assets/img/logo/logo-red-2.png';

const FooterThree = (props) => {
  const { footerClass, footerLogo } = props;
  return (
    <footer>
      <div
        className={
          footerClass
            ? footerClass
            : 'it-footer-area it-footer-style-5 black-bg fix z-index p-relative pb-70'
        }
        style={{ backgroundImage: `url(${footerBG})` }}
      >
        <div className="it-footer-top-area pt-115 pb-120 mb-120">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="it-footer-top-left">
                  <h3 className="it-footer-top-title text-white">
                    25+ Hospitals
                  </h3>
                  <p className="mb-0">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do <br /> eiusmod tempor incididunt ut labore et dolore
                    magna aliqua. Ut <br /> enim ad minim veniam, quis nostrud
                  </p>
                </div>
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6">
                <div className="it-footer-top-right">
                  <h3 className="it-footer-top-right-title text-white mb-15">
                    Subscribe With Us
                  </h3>
                  <p>For any help mail us. 24/7 emergency services</p>
                  <div className="it-footer-input-box p-relative mt-30">
                    <form action="#">
                      <input type="email" placeholder="Your email address" />
                      <button className="it-btn-theme red-bg">
                        <Button btnText="Subscribe" />
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div
              className="col-xxl-4 col-xl-4 col-lg-5 col-md-6 col-sm-10 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div className="it-footer-widget footer-col-1">
                <div className="it-footer-logo">
                  <Link to="/">
                    <img src={footerLogo ? footerLogo : Logo} alt="" />
                  </Link>
                </div>
                <div className="it-footer-text pb-15">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris .
                  </p>
                  <span>
                    Interdum velit laoreet id donec ultrices tincidunt arcu.
                  </span>
                  <p>
                    Tincidunt tortor aliquam nulla facilisi cras fermentum odio
                    eu.
                  </p>
                </div>
                <div className="it-footer-social">
                  <a href="#">
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                  <a href="#">
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                  <a href="#">
                    <i className="fa-brands fa-pinterest-p"></i>
                  </a>
                  <a href="#">
                    <i className="fa-brands fa-twitter"></i>
                  </a>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-7 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".5s"
            >
              <div className="it-footer-widget footer-col-2">
                <h4 className="it-footer-widget-title">our services:</h4>
                <div className="it-footer-list">
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>Cardiology
                        Care
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>Urgent Care
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>Orthopedic
                        Care
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>Diagnosis
                        department
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>
                        Gastroenterology
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>Therapy
                        department
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>Dental
                        service
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-2 col-lg-3 col-md-6 col-sm-5 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".7s"
            >
              <div className="it-footer-widget footer-col-3">
                <h4 className="it-footer-widget-title">quick links:</h4>
                <div className="it-footer-list">
                  <ul>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>About Us
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i> Our
                        Services
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i> Our Team
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>Latest Blog
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>
                        Appointments
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>Help & FAQs
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <i className="fa-regular fa-angle-right"></i>Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-50 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".9s"
            >
              <div className="it-footer-widget footer-col-4">
                <h4 className="it-footer-widget-title">newsletter:</h4>
                <div className="it-footer-input-box p-relative mb-25">
                  <form action="#">
                    <input
                      className="mb-30"
                      type="email"
                      placeholder="Enter your email:"
                    />
                    <button className="it-btn-theme red-bg">
                      <Button btnText="Subscribe now" />
                    </button>
                  </form>
                </div>
                <div className="it-footer-agree">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                      I agree to email receive.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-copyright-area it-copyright-height it-copyright-style-4">
        <div className="container">
          <div className="row">
            <div
              className="col-12 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay=".3s"
            >
              <div className="it-copyright-text text-center">
                <p>
                  Copyright © 2024 <a href="#">Medito</a> || All Rights Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterThree;
